module.exports = __webpack_public_path__ + "static/media/25-7.0fbdd83d.mp3";